export enum PolicyStepState {
  DATE = 'DATE',
  REASON = 'REASON',
}

export enum Bookmarks {
  insuranceTypeDisplayName = 'insuranceTypeDisplayName',
  insuranceTypeDisplayDetails = 'insuranceTypeDisplayDetails',
  email = 'email',
}

export const reasonCodes = {
  otherReasonSitecoreId: 'FE821D42-6533-4656-9D30-BDE9431C245F',
  freeLookReasonSitecoreId: '34B7EF33-DB4E-49DE-AC85-A2560463B965',
};

export function buildDropDown(selectedOption: any) {
  if (!selectedOption || !selectedOption.children?.length) return null;

  return {
    type: selectedOption.listAsRadio ? 'radio' : 'dropdown',
    label: selectedOption.listLabel,
    requiredErrorMessage: selectedOption.requiredErrorMessage,
    options: selectedOption.children.map((item: any) => ({
      value: item.id,
      label: item.listValue,
    })),
    children: selectedOption.children,
    triggerChangeVehicle: selectedOption.triggerChangeVehicle,
    additionalCommentsRequired: selectedOption.additionalCommentsRequired,
  };
}
